import SearchActivities from './SearchActivities';

export default SearchActivities;
